// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3E-5i","info":"Note_info__uqPGC","note":"Note_note__3LZZb","actions":"Note_actions__32mJ1"};